import { parseISO } from 'date-fns';

export type TDateCellValue = string | Date;

function dateFormatter(date?: TDateCellValue): string {
  if (!date) return '';
  if (date instanceof Date) return date.toLocaleString();

  try {
    return parseISO(date).toLocaleString();
  } catch (_) {
    return '';
  }
}

export { dateFormatter };
